import axios from "./themeInstance"
export default async (id:string) => {
  try {
    const response: any = await axios.delete(`/themes/${id}`);
    return response.data
  } catch (error) {
    return null
  }
}
